import { render, staticRenderFns } from "./UserInfoComponent.vue?vue&type=template&id=6b59cbed&scoped=true&"
import script from "./UserInfoComponent.vue?vue&type=script&lang=js&"
export * from "./UserInfoComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b59cbed",
  null
  
)

export default component.exports